export default {
    "DeFi Binance": "DeFi Binance",
    "流动性挖矿": "Mining di liquidità",
    "加入节点， 开始挖矿": "Unisciti al nodo, inizia il mining",
    "参 与": "Partecipa",
    "矿池数据": "Dati del pool",
    "总产量": "Produzione totale",
    "有效节点": "Nodi attivi",
    "参与者": "Partecipanti",
    "用户收入": "Entrate utente",
    "挖矿榜单": "Classifica mining",
    "流动性挖矿收入": "Guadagni dal mining di liquidità",
    "输出记录": "Registro output",
    "地址": "Indirizzo",
    "数量": "Quantità",
    "帮助中心": "Centro assistenza",
    "希望它可以帮助你": "Speriamo possa aiutarti",
    "安全保障": "Sicurezza garantita",
    "我们有安全的审计报告": "Abbiamo report di audit sicuri",
    "伙伴": "Partner",
    "我们的商业伙伴": "I nostri partner commerciali",
    "首页": "Home",
    "我的矿池": "Il mio pool",
    "提取": "Preleva",
    "账户": "Account",
    "总挖矿金额": "Importo totale mining",
    "可更换": "Sostituibile",
    "收益率": "Rendimento",
    "币池名称": "Nome del pool",
    "最低金额": "Importo minimo",
    "收益率/24小时": "Rendimento/24 ore",
    "挖矿记录": "Storico mining",
    "金额": "Importo",
    "描述": "Descrizione",
    "时间": "Orario",
    "已参与": "Partecipato",
    "质 押": "Staking",
    "已质押": "In staking",
    "记录": "Registro",
    "兑换": "Converti",
    "从": "Da",
    "全部": "Tutto",
    "至": "A",
    "价格": "Prezzo",
    "确认": "Conferma",
    "矿池收益": "Profitti pool",
    "今日收益": "Profitti odierni",
    "普通矿池": "Pool standard",
    "高级矿池": "Pool avanzato",
    "全部的": "Tutti",
    "可用的": "Disponibile",
    "申请加入": "Richiedi adesione",
    "推荐朋友": "Consiglia amici",
    "一起赚取加密货币": "Guadagna cripto insieme",
    "查看详情": "Vedi dettagli",
    "团队": "Team",
    "推荐": "Referenze",
    "团队规模": "Dimensione del team",
    "直接发起人": "Sponsor diretto",
    "总收入": "Entrate totali",
    "今天的收入": "Entrate di oggi",
    "我的推荐链接": "Il mio link di referenza",
    "复制": "Copia",
    "1. 获取链接": "1. Ottieni il link",
    "2. 邀请朋友": "2. Invita amici",
    "3. 赚取加密货币": "3. Guadagna cripto",
    "等级": "Livello",
    "1 级": "Livello 1",
    "2 级": "Livello 2",
    "3 级": "Livello 3",
    "用户地址": "Indirizzo utente",
    "币种": "Token",
    "说明": "Dettagli",
    "状态": "Stato",
    "定时收益": "Entrate programmate",
    "今日预收益": "Entrate previste oggi",
    "累计收益": "Entrate cumulative",
    "将矿池收益的BNB兑换成USDT后立即到账": "Converti i profitti in BNB in USDT immediatamente",
    "将USDT提取后会在24小时内到达你的钱包": "Il prelievo di USDT arriverà in 24 ore",
    "天": "Giorni",
    "高级矿池收益": "Profitti pool avanzato",
    "质押收益": "Profitti staking",
    "下次收益": "Prossimi profitti",
    "当前收益率": "Rendimento attuale",
    "昨日收益": "Profitti di ieri",
    "普通矿池收益率": "Rendimento pool standard",
    "高级矿池收益率": "Rendimento pool avanzato",
    "高级矿池限时开放": "Pool avanzato aperto a tempo limitato",
	"公告":"annuncio",
	"我知道了":"Vedo"
};
